import type { QueryClient } from "@tanstack/react-query";

export function invalidateTrustSuitePipeline(queryClient: QueryClient, municipalityId: number) {
  queryClient.invalidateQueries({ queryKey: ["trust_complaints", municipalityId] });
}
